import Pagination from "../../../components/Pagination/Pagination";
import "./RecentSales.css";
const RecentSales = ({ setRecentSalesModal }) => {
 return (
  <div className="sales-recent-sales">
   <p className="title">18903 Results</p>

   <div className="recent-sales-container desktop">
    <table>
     <thead>
      <tr>
       <th>TRANSACTION ID</th>
       <th>PRODUCT</th>
       <th>BUYER</th>
       <th>AMOUNT</th>
       <th>COMMISSION</th>
       <th>DATE CREATED</th>
      </tr>
     </thead>

     <tbody>
      <tr>
       <td>RUBRWA354</td>
       <td>Mind games of a broken heart</td>
       <td>Darlene Robertson</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>

      <tr>
       <td>RUBRWA354</td>
       <td>Mind games of a broken heart</td>
       <td>Darlene Robertson</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>
      <tr>
       <td>RUBRWA354</td>
       <td>Mind games of a broken heart</td>
       <td>Darlene Robertson</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>
      <tr>
       <td>RUBRWA354</td>
       <td>Mind games of a broken heart</td>
       <td>Darlene Robertson</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>
      <tr>
       <td>RUBRWA354</td>
       <td>Mind games of a broken heart</td>
       <td>Darlene Robertson</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>

      <tr>
       <td>RUBRWA354</td>
       <td>Mind games of a broken heart</td>
       <td>Darlene Robertson</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>

      <tr>
       <td>RUBRWA354</td>
       <td>Mind games of a broken heart</td>
       <td>Darlene Robertson</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>
     </tbody>
    </table>

    <div className="pagination-wrapper">
     <Pagination />
    </div>
   </div>

   <div className="recent-sales-container mobile">
    <div className="card" onClick={() => setRecentSalesModal(true)}>
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="card" onClick={() => setRecentSalesModal(true)}>
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="card">
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="card">
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="card">
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="pagination-wrapper">
     <Pagination />
    </div>
   </div>
  </div>
 );
};

export default RecentSales;
